import ApplicationSerializer from 'eflex/serializers/application';

export default class WieConfigShapeSerializer extends ApplicationSerializer {
  attrs = {
    stroke: {
      embedded: 'always',
    },
    fill: {
      embedded: 'always',
    },
  };
}
